// One row per crew, not per shift: the report aggregates everything a crew did
// across all its shifts in the range. The legacy screen labels the crew column
// "Shift", which is where the report's name comes from.
export interface ShiftsRow {
	CrewId: string;
	ProductsCount: number | null;
	Tonnage: number | null;
	ProductChangesCount: number | null;
	// Seconds. An open stop counts up to now, so these move between refreshes.
	DelaysDuration: number | null;
	BarSetupDelaysDuration: number | null;
	// Already a percentage, 0-100.
	ShiftUtilization: number | null;
	CobblesCount: number | null;
	CobblesDuration: number | null;
}

// The legacy computes this in the browser and the procedure never returns it.
export const cobblesRate = (row: ShiftsRow): number | null => {
	if (!row.ProductsCount) return null;
	return ((row.CobblesCount ?? 0) * 100) / row.ProductsCount;
};
